 import {getStockList} from "@/api/Stock"

 export default {
   saveStock({
     commit
   }, stocks) {
     return new Promise((resolve, reject) => {
       commit('SAVE_STOCK', stocks)
       resolve()
         .catch((error) => {
           reject(error)
         })
     })
   },
   fetchDataListItemsStock({
     commit
   }, payload) {
     return new Promise((resolve, reject) => {
      getStockList(payload)
         .then((response) => {
           if (response.status === 200) {
             commit('SET_STOCK', response.data);
             resolve(response);
           } else {
             reject(new Error("Listeleme İşlemi Başarısız ! " + response.status));
           }
         })
         .catch(error => {
           reject(new Error("Sunucu Bağlantısı Başarısız !"));
         })
     })
   },
   removeStock({
     commit
   }, stockId) {
     return new Promise((resolve, reject) => {
       commit('REMOVE_STOCK', stockId)
       resolve();
     })
   }
 };